<template>
  <div id="userinfo">
    <h1>ユーザー情報</h1>
    <div class="info">
      <table>
        <tr>
          <th>名前</th><td>:</td><td>{{$store.state.userInfo.fullname}}（{{ userType }}）</td>
        </tr>
        <tr>
          <th>カナ</th><td>:</td><td>{{$store.state.userInfo.kana}}</td>
        </tr>
        <tr>
          <th>ユーザー名(ID)</th><td>:</td><td>{{ $store.state.userInfo.user_name }}</td>
        </tr>
        <tr>
          <th>mail</th><td>:</td><td>{{ $store.state.userInfo.mail_address }}</td>
        </tr>
      </table>
    </div>
    <router-link tag="button" to="/Spchangeuser" title="予約変更" class="button">
      <span>情報を変更する</span>
    </router-link>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'userinfo',
  deta () {
    return {
      userType: null
    }
  },
  methods: {
    ...mapActions([
      'getUserInfo',
      'getInformation'
    ]),
    getinformation () {
      this.getInformation().then((res) => {
      })
    }
  },
  created () {
    this.getUserInfo().then((res) => {
    })
    if (this.$store.state.userInfo.user_type === 'admin') {
      this.userType = '管理者'
    } else if (this.$store.state.userInfo.user_type === 'teacher') {
      this.userType = '教師'
    } else if (this.$store.state.userInfo.user_type === 'student') {
      this.userType = '生徒'
    } else {
      this.userType = '閲覧者'
    }
  }
}
</script>

<style scoped>
#userinfo{
  width: 100%;
  text-align: center;
}
h1{
  width: 80%;
  margin: auto;
  margin-top: 5px;
}
table{
  margin: auto;
  width: 90%;
}
table tr{
  border-bottom: solid 1px rgb(224, 169, 85);
}
.info{
  margin: auto;
  padding: 2vw;
  width: 90%;
  border: solid 2px rgb(255, 200, 6);
  border-radius: 7px;
}
.button{
  width: 50%;
  height: 10vh;
  margin: 10px;
  border: solid 3px rgb(255, 148, 6);
  border-radius: 5px;
  background-color: rgb(255, 214, 125);
  font-size:  5vw;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// SpUserInfo.vue?0187c04c